import React, { useState } from 'react';
import { Checkbox, Button, FModal, Icons } from '@components';
import { TransformacaoBeneficioService } from '@services';
import { useSelector } from 'react-redux';
import { mdiCommentAlertOutline } from '@mdi/js';

export const TermoConsentimento = ({
  dadosIniciais,
  dados,
  callback,
  prevActiveStep,
}) => {
  const user = useSelector((state) => state.user);
  const [modalSolicitationIsOpen, setModalSolicitationIsOpen] = useState(false);
  const [msgResponse, setMsgResponse] = useState('');
  const [termoAceite, setTermoAceite] = useState(false);

  const solicitarTransfBeneficio = async () => {
    const transformacaoBenService = new TransformacaoBeneficioService();

    const retornoSolicitacao =
      await transformacaoBenService.setSolicitacaoTransformacaoBeneficio({
        matricula: user.matricula,
        reserva: dadosIniciais.reservaMatematica,
        percentual: parseFloat(dados.percRenda),
        renda: dados.rendaMensalInicial,
      });

    setMsgResponse(
      !retornoSolicitacao
        ? 'Solicitação realizada com sucesso'
        : retornoSolicitacao
    );
    setModalSolicitationIsOpen(true);
  };

  return (
    <div className="mt-32 ms-4">
      <h1 className="ts-28 fw-bold mb-1 text-orange mb-32">Termo</h1>
      <div>
        <p className="ts-20">
          Venho, por meio deste, plenamente ciente das implicações do presente
          ato, por livre e espontânea vontade, nos termos estipulados no artigo
          68 do Regulamento do Plano Misto de Benefícios Previdenciários - Plano
          B da Fundação Forluzminas de Seguridade Social - FORLUZ, exercer a
          opção de transformação da forma de recebimento atual do meu benefício
          para benefício de prestação continuada pago sob a forma temporária em
          valor variável definida por percentual do saldo remanescente da Conta
          de Aposentadoria, prevista do artigo 26, inciso III. <br />
          <br />
          <b>
            Ao optar pela transformação de recebimento em Renda Temporária em
            Valor Variável no percentual de {dados.percRenda}
            %, declaro ter pleno conhecimento de que:
          </b>
          <br />1 - A rentabilidade mensal aplicável sobre o saldo de minha
          conta, após entrar em gozo desta modalidade de benefício, será aquela
          auferida sobre os recursos garantidores do perfil definido pela
          Diretoria Executiva, podendo ser posteriormente alterado nas
          respectivas janelas de alteração.
          <br />2 - O saldo de minha conta dependerá da rentabilidade obtida e
          do valor do benefício.
          <br />3 - Não há garantia de rentabilidade mínima, podendo, inclusive,
          ocorrer rentabilidade negativa.
          <br />4 - O valor do benefício dependerá do saldo de conta e do
          percentual escolhido e será recalculado anualmente.
          <br /> 5 - O benefício se encerrará quando se exaurir o saldo mínimo
          de minha conta.
          {dadosIniciais.pessoasGrupoFamiliar > 1 && (
            <>
              <br />
              <span>
                6 - O pedido individual de transformação de recebimento será
                acatado pela Fundação Forluzminas de Seguridade Social - FORLUZ
                somente se todos os pensionistas vinculados à reserva matemática
                manifestarem opção pela transformação. Na ausência de uma ou
                mais manifestações, o pleito será indeferido.
              </span>
            </>
          )}
          <br />
          <br />
          <b>
            Reconheço que, em razão do presente ato jurídico de opção, ficam
            extintos meus direitos e os dos meus beneficiários decorrentes do
            conteúdo do artigo 26, inciso I, e inciso IV, alínea a, e do artigo
            32, inciso V, renunciando, portanto, a todos os meus direitos,
            pretensões e ações decorrentes, para nada mais reclamar, em tempo
            algum, em juízo ou fora dele, dado plena, rasa e geral quitação no
            tocante a eles.
          </b>
        </p>
      </div>
      <div className="row mt-32 justify-content-start">
        <div className="col-2">
          <Button
            className="col-2"
            onClick={() => callback(prevActiveStep - 1)}
          >
            Anterior
          </Button>
        </div>
        <div className="col-8 d-flex align-items-center">
          <Checkbox
            className="beneficiario_checkbox"
            defaultChecked={termoAceite}
            onChange={setTermoAceite}
            disabledCheckbox={termoAceite}
          />
          <p className="text-muted ts-18">
            Desejo prosseguir com a transformação do benefício
          </p>
        </div>
        <div className="col-2">
          <Button
            disabled={!termoAceite}
            className="col-2"
            onClick={solicitarTransfBeneficio}
          >
            Continuar
          </Button>
        </div>
      </div>
      <div />
      <FModal
        isOpen={modalSolicitationIsOpen}
        close
        onClose={() => setModalSolicitationIsOpen(false)}
      >
        <Icons
          path={mdiCommentAlertOutline}
          color="var(--primary-color)"
          size={2}
          style={{ marginRight: 4 }}
        />
        <h1 className="ts-20 fw-bold mb-1">{msgResponse}</h1>
        <Button
          className="mt-32"
          onClick={() => {
            setModalSolicitationIsOpen(false);
            callback(0);
          }}
        >
          Ok
        </Button>
      </FModal>
    </div>
  );
};
